var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-content pl-2 pr-2" },
    [
      _c("label", [_vm._v("For")]),
      _vm._v(" "),
      _vm._l(_vm.payload.dateRanges, function (dateRange) {
        return _c("div", [
          _vm._v(
            "\n        " + _vm._s(_vm.getDateRangeText(dateRange)) + "\n    "
          ),
        ])
      }),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n        Values left blank will not be updated.\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-4 mb-4 d-flex flex-wrap" },
        [
          _c("label", [_vm._v("\n            Toggle all Selected\n        ")]),
          _vm._v(" "),
          _c(
            "v-switch",
            {
              model: {
                value: _vm.guideRateToggle,
                callback: function ($$v) {
                  _vm.guideRateToggle = $$v
                },
                expression: "guideRateToggle",
              },
            },
            [
              _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Guide Rate"),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-switch",
            {
              model: {
                value: _vm.availabilityOnRequestToggle,
                callback: function ($$v) {
                  _vm.availabilityOnRequestToggle = $$v
                },
                expression: "availabilityOnRequestToggle",
              },
            },
            [
              _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v("Availability On Request"),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.payload.rangeHasClosedDates
        ? _c("div", { staticClass: "d-flex align-center" }, [
            _c(
              "div",
              { staticClass: "mb-2 pl-1 pt-2 pb-2 red rounded" },
              [
                _c("v-icon", { staticClass: "mr-4 amber--text" }, [
                  _vm._v("warning"),
                ]),
                _c("label", [
                  _vm._v(
                    "Whole Property is Closed from " +
                      _vm._s(_vm.payload.rangeClosedDatesFrom)
                  ),
                ]),
                _c("v-icon", { staticClass: "ml-4 amber--text" }, [
                  _vm._v("warning"),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.payload.errorMessage
        ? _c("div", { staticClass: "d-flex align-center" }, [
            _c(
              "div",
              { staticClass: "mb-2 pl-1 pt-2 pb-2 red rounded" },
              [
                _c("v-icon", { staticClass: "mr-4 amber--text" }, [
                  _vm._v("warning"),
                ]),
                _c("label", [_vm._v(_vm._s(_vm.payload.errorMessage))]),
                _c("v-icon", { staticClass: "ml-4 amber--text" }, [
                  _vm._v("warning"),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.payload.selectClosed
        ? _c("div", { staticClass: "d-flex align-center" }, [
            _c(
              "div",
              { staticClass: "mb-2 pl-1 pt-2 pb-2 red rounded" },
              [
                _c("v-icon", { staticClass: "mr-4 amber--text" }, [
                  _vm._v("warning"),
                ]),
                _c("label", [_vm._v("Property is Closed")]),
                _c("v-icon", { staticClass: "ml-4 amber--text" }, [
                  _vm._v("warning"),
                ]),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.payload.hotelRooms, function (hotelRoom) {
        return _vm.payload.selectedHotelRooms.includes(
          hotelRoom.hotelRoomKey
        ) && !_vm.payload.selectClosed
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "pl-1 pt-1 pb-1 room-name d-flex justify-space-between",
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(hotelRoom.name) +
                        " (" +
                        _vm._s(hotelRoom.standardOccupancy) +
                        " pax)"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-end pr-2" }, [
                    _vm._v(" (0 - " + _vm._s(hotelRoom.totalNumRooms) + ")"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _vm.payload.selectAvailability
                    ? _c(
                        "div",
                        { staticClass: "pl-1 pt-1 pb-0 d-flex flex-wrap" },
                        [
                          _c(
                            "div",
                            {
                              class: [
                                "mr-6 d-flex value align-center",
                                _vm.getAvailabilityStatusClass(
                                  hotelRoom.hotelRoomKey
                                ),
                              ],
                            },
                            [_c("span", [_vm._v("Availability")])]
                          ),
                          _vm._v(" "),
                          _c("v-text-field", {
                            staticClass: "mr-2 pt-0 mt-0 value",
                            attrs: {
                              "hide-details": "",
                              density: "compact",
                              type: "text",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.debouncedCheckAvailabilityClash(
                                  hotelRoom.hotelRoomKey,
                                  "quantity"
                                )
                              },
                              change: function ($event) {
                                return _vm.updateAvailability(
                                  hotelRoom.hotelRoomKey,
                                  "quantity"
                                )
                              },
                            },
                            model: {
                              value:
                                _vm.availabilityValues[hotelRoom.hotelRoomKey][
                                  "quantity"
                                ],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.availabilityValues[
                                    hotelRoom.hotelRoomKey
                                  ],
                                  "quantity",
                                  $$v
                                )
                              },
                              expression:
                                "availabilityValues[hotelRoom.hotelRoomKey]['quantity']",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "max-width": "50px" } },
                            [
                              _vm.availabilityClashes[hotelRoom.hotelRoomKey][
                                "quantity"
                              ]
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "red--text",
                                      attrs: {
                                        title:
                                          _vm.availabilityClashes[
                                            hotelRoom.hotelRoomKey
                                          ]["quantity"],
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        warning\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            staticClass: "mr-2 mt-0 pt-0 value",
                            attrs: {
                              "hide-details": "",
                              "item-text": "text",
                              "item-value": "value",
                              items: _vm.availabilityStatuses,
                              placeholder: "Availability Status",
                              clearable: "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.debouncedCheckAvailabilityClash(
                                  hotelRoom.hotelRoomKey,
                                  "status_key"
                                )
                              },
                              change: function ($event) {
                                return _vm.updateAvailability(
                                  hotelRoom.hotelRoomKey,
                                  "status_key"
                                )
                              },
                            },
                            model: {
                              value:
                                _vm.availabilityValues[hotelRoom.hotelRoomKey][
                                  "status_key"
                                ],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.availabilityValues[
                                    hotelRoom.hotelRoomKey
                                  ],
                                  "status_key",
                                  $$v
                                )
                              },
                              expression:
                                "availabilityValues[hotelRoom.hotelRoomKey]['status_key']",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "max-width": "50px" } },
                            [
                              _vm.availabilityClashes[hotelRoom.hotelRoomKey][
                                "status_key"
                              ]
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "red--text",
                                      attrs: {
                                        title:
                                          _vm.availabilityClashes[
                                            hotelRoom.hotelRoomKey
                                          ]["status_key"],
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        warning\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.payload.rateTypes, function (rateType) {
                    return _vm.payload.selectedRateTypes.includes(
                      rateType.rateTypeKey
                    ) && _vm.roomHasRateType(hotelRoom, rateType.rateTypeKey)
                      ? _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "pl-1 pt-1 pb-1 d-flex flex-wrap",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "white--text mr-6 value d-flex align-center",
                                      _vm.getRateStatusClass(
                                        hotelRoom.hotelRoomKey,
                                        rateType.rateTypeKey
                                      ),
                                    ],
                                  },
                                  [_c("span", [_vm._v(_vm._s(rateType.name))])]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "mr-2 pt-0 mt-0 value",
                                  attrs: {
                                    density: "compact",
                                    "hide-details": "",
                                    type: "text",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.debouncedCheckRateClash(
                                        rateType.rateTypeKey,
                                        hotelRoom.hotelRoomKey,
                                        "rate_standard"
                                      )
                                    },
                                    change: function ($event) {
                                      return _vm.updateStandardRate(
                                        hotelRoom.hotelRoomKey,
                                        rateType.rateTypeKey,
                                        "rate_standard"
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.rateValues[hotelRoom.hotelRoomKey][
                                        rateType.rateTypeKey
                                      ]["rate_standard"],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rateValues[hotelRoom.hotelRoomKey][
                                          rateType.rateTypeKey
                                        ],
                                        "rate_standard",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "rateValues[hotelRoom.hotelRoomKey][rateType.rateTypeKey]['rate_standard']",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { "max-width": "50px" } },
                                  [
                                    _vm.rateClashes[hotelRoom.hotelRoomKey][
                                      rateType.rateTypeKey
                                    ]["rate_standard"]
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "red--text",
                                            attrs: {
                                              title:
                                                _vm.rateClashes[
                                                  hotelRoom.hotelRoomKey
                                                ][rateType.rateTypeKey][
                                                  "rate_standard"
                                                ],
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            warning\n                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-select", {
                                  staticClass: "mr-2 mt-0 pt-0 value",
                                  attrs: {
                                    "hide-details": "",
                                    "item-text": "text",
                                    "item-value": "value",
                                    items: _vm.rateStatuses,
                                    clearable: "",
                                    placeholder: "Rate Type",
                                  },
                                  on: {
                                    input: function ($event) {
                                      return _vm.debouncedCheckRateClash(
                                        rateType.rateTypeKey,
                                        hotelRoom.hotelRoomKey,
                                        "rate_status"
                                      )
                                    },
                                    change: function ($event) {
                                      return _vm.updateStandardRate(
                                        hotelRoom.hotelRoomKey,
                                        rateType.rateTypeKey,
                                        "rate_status"
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.rateValues[hotelRoom.hotelRoomKey][
                                        rateType.rateTypeKey
                                      ]["rate_status"],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.rateValues[hotelRoom.hotelRoomKey][
                                          rateType.rateTypeKey
                                        ],
                                        "rate_status",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "rateValues[hotelRoom.hotelRoomKey][rateType.rateTypeKey]['rate_status']",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { "max-width": "50px" } },
                                  [
                                    _vm.rateClashes[hotelRoom.hotelRoomKey][
                                      rateType.rateTypeKey
                                    ]["rate_status"]
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticClass: "red--text",
                                            attrs: {
                                              title:
                                                _vm.rateClashes[
                                                  hotelRoom.hotelRoomKey
                                                ][rateType.rateTypeKey][
                                                  "rate_status"
                                                ],
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                            warning\n                        "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.payload.additionalRates,
                              function (additionalRate) {
                                return _c("div", [
                                  _vm.payload.selectedAdditionalRates.includes(
                                    additionalRate.field
                                  ) &&
                                  !_vm.hasUniversalRates &&
                                  hotelRoom[additionalRate.field]
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mb-1 pl-1 d-flex flex-wrap",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "grey white--text mr-6 value d-flex align-center",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(additionalRate.text)
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            staticClass: "mr-2 pt-0 mt-0 value",
                                            attrs: {
                                              density: "compact",
                                              "hide-details": "",
                                              type: "text",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.debouncedCheckRateClash(
                                                  rateType.rateTypeKey,
                                                  hotelRoom.hotelRoomKey,
                                                  additionalRate.field
                                                )
                                              },
                                              change: function ($event) {
                                                return _vm.updateAdditionalRate(
                                                  hotelRoom.hotelRoomKey,
                                                  rateType.rateTypeKey,
                                                  additionalRate.field
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.rateValues[
                                                  hotelRoom.hotelRoomKey
                                                ][rateType.rateTypeKey][
                                                  additionalRate.field
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.rateValues[
                                                    hotelRoom.hotelRoomKey
                                                  ][rateType.rateTypeKey],
                                                  additionalRate.field,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "rateValues[hotelRoom.hotelRoomKey][rateType.rateTypeKey][additionalRate.field]",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "max-width": "50px",
                                              },
                                            },
                                            [
                                              _vm.rateClashes[
                                                hotelRoom.hotelRoomKey
                                              ][rateType.rateTypeKey][
                                                additionalRate.field
                                              ]
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "red--text",
                                                      attrs: {
                                                        title:
                                                          _vm.rateClashes[
                                                            hotelRoom
                                                              .hotelRoomKey
                                                          ][
                                                            rateType.rateTypeKey
                                                          ][
                                                            additionalRate.field
                                                          ],
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                warning\n                            "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              }
                            ),
                            _vm._v(" "),
                            _vm.payload.selectedRestrictions.includes(
                              "min_stay"
                            )
                              ? _c(
                                  "div",
                                  { staticClass: "mb-1 pl-1 d-flex flex-wrap" },
                                  [
                                    _vm._m(0, true),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      staticClass: "mr-2 pt-0 mt-0 value",
                                      attrs: {
                                        density: "compact",
                                        "hide-details": "",
                                        type: "text",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.debouncedCheckRateClash(
                                            rateType.rateTypeKey,
                                            hotelRoom.hotelRoomKey,
                                            "min_stay"
                                          )
                                        },
                                        change: function ($event) {
                                          return _vm.updateRestriction(
                                            hotelRoom.hotelRoomKey,
                                            rateType.rateTypeKey,
                                            "min_stay"
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.rateValues[
                                            hotelRoom.hotelRoomKey
                                          ][rateType.rateTypeKey]["min_stay"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.rateValues[
                                              hotelRoom.hotelRoomKey
                                            ][rateType.rateTypeKey],
                                            "min_stay",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "rateValues[hotelRoom.hotelRoomKey][rateType.rateTypeKey]['min_stay']",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.rateClashes[hotelRoom.hotelRoomKey][
                                      rateType.rateTypeKey
                                    ]["min_stay"]
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "max-width": "50px",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "red--text",
                                                attrs: {
                                                  title:
                                                    _vm.rateClashes[
                                                      hotelRoom.hotelRoomKey
                                                    ][rateType.rateTypeKey][
                                                      "min_stay"
                                                    ],
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            warning\n                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.payload.selectedRestrictions.includes(
                              "max_stay"
                            )
                              ? _c(
                                  "div",
                                  { staticClass: "mb-1 pl-1 d-flex flex-wrap" },
                                  [
                                    _vm._m(1, true),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      staticClass: "mr-2 pt-0 mt-0 value",
                                      attrs: {
                                        density: "compact",
                                        "hide-details": "",
                                        type: "text",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.debouncedCheckRateClash(
                                            rateType.rateTypeKey,
                                            hotelRoom.hotelRoomKey,
                                            "max_stay"
                                          )
                                        },
                                        change: function ($event) {
                                          return _vm.updateRestriction(
                                            hotelRoom.hotelRoomKey,
                                            rateType.rateTypeKey,
                                            "max_stay"
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.rateValues[
                                            hotelRoom.hotelRoomKey
                                          ][rateType.rateTypeKey]["max_stay"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.rateValues[
                                              hotelRoom.hotelRoomKey
                                            ][rateType.rateTypeKey],
                                            "max_stay",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "rateValues[hotelRoom.hotelRoomKey][rateType.rateTypeKey]['max_stay']",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.rateClashes[hotelRoom.hotelRoomKey][
                                      rateType.rateTypeKey
                                    ]["max_stay"]
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "max-width": "50px",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "red--text",
                                                attrs: {
                                                  title:
                                                    _vm.rateClashes[
                                                      hotelRoom.hotelRoomKey
                                                    ][rateType.rateTypeKey][
                                                      "max_stay"
                                                    ],
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            warning\n                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.payload.selectedRestrictions.includes(
                              "days_checkin"
                            ) && rateType.is_checkinout_variable
                              ? _c(
                                  "div",
                                  { staticClass: "mb-1 pl-1 d-flex flex-wrap" },
                                  [
                                    _vm._m(2, true),
                                    _vm._v(" "),
                                    _c("v-select", {
                                      staticClass: "mr-2 mt-0 pt-0 value",
                                      attrs: {
                                        "hide-details": "",
                                        "item-text": "text",
                                        "item-value": "value",
                                        items: _vm.checkInOutStatuses,
                                        clearable: "",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.debouncedCheckRateClash(
                                            rateType.rateTypeKey,
                                            hotelRoom.hotelRoomKey,
                                            "days_checkin"
                                          )
                                        },
                                        change: function ($event) {
                                          return _vm.updateRestriction(
                                            hotelRoom.hotelRoomKey,
                                            rateType.rateTypeKey,
                                            "days_checkin"
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.rateValues[
                                            hotelRoom.hotelRoomKey
                                          ][rateType.rateTypeKey][
                                            "days_checkin"
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.rateValues[
                                              hotelRoom.hotelRoomKey
                                            ][rateType.rateTypeKey],
                                            "days_checkin",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "rateValues[hotelRoom.hotelRoomKey][rateType.rateTypeKey]['days_checkin']",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.rateClashes[hotelRoom.hotelRoomKey][
                                      rateType.rateTypeKey
                                    ]["days_checkin"]
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "max-width": "50px",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "red--text",
                                                attrs: {
                                                  title:
                                                    _vm.rateClashes[
                                                      hotelRoom.hotelRoomKey
                                                    ][rateType.rateTypeKey][
                                                      "days_checkin"
                                                    ],
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            warning\n                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.payload.selectedRestrictions.includes(
                              "days_checkout"
                            ) && rateType.is_checkinout_variable
                              ? _c(
                                  "div",
                                  { staticClass: "mb-1 pl-1 d-flex flex-wrap" },
                                  [
                                    _vm._m(3, true),
                                    _vm._v(" "),
                                    _c("v-select", {
                                      staticClass: "mr-2 mt-0 pt-0 value",
                                      attrs: {
                                        "hide-details": "",
                                        "item-text": "text",
                                        "item-value": "value",
                                        items: _vm.checkInOutStatuses,
                                        clearable: "",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.debouncedCheckRateClash(
                                            rateType.rateTypeKey,
                                            hotelRoom.hotelRoomKey,
                                            "days_checkout"
                                          )
                                        },
                                        change: function ($event) {
                                          return _vm.updateRestriction(
                                            hotelRoom.hotelRoomKey,
                                            rateType.rateTypeKey,
                                            "days_checkout"
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.rateValues[
                                            hotelRoom.hotelRoomKey
                                          ][rateType.rateTypeKey][
                                            "days_checkout"
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.rateValues[
                                              hotelRoom.hotelRoomKey
                                            ][rateType.rateTypeKey],
                                            "days_checkout",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "rateValues[hotelRoom.hotelRoomKey][rateType.rateTypeKey]['days_checkout']",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.rateClashes[hotelRoom.hotelRoomKey][
                                      rateType.rateTypeKey
                                    ]["days_checkout"]
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "max-width": "50px",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "red--text",
                                                attrs: {
                                                  title:
                                                    _vm.rateClashes[
                                                      hotelRoom.hotelRoomKey
                                                    ][rateType.rateTypeKey][
                                                      "days_checkout"
                                                    ],
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                            warning\n                        "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e()
                  }),
                ],
                2
              ),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.hasUniversalRates
        ? _c(
            "div",
            [
              _vm._m(4),
              _vm._v(" "),
              _vm._l(_vm.universalRateColumns, function (universalRate) {
                return _c("div", [
                  universalRate in _vm.payload.universalRates &&
                  _vm.payload.selectedAdditionalRates.includes(
                    _vm.getEquivalentRateDateColumn(universalRate)
                  )
                    ? _c(
                        "div",
                        { staticClass: "mb-1 pl-1 d-flex flex-wrap" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "grey white--text mr-6 value d-flex align-center",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getUniversalRateText(universalRate)
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-text-field", {
                            staticClass: "mr-2 pt-0 mt-0 value",
                            attrs: {
                              density: "compact",
                              "hide-details": "",
                              type: "text",
                              placeholder: _vm.getUniversalRatePlaceholder(
                                _vm.payload.universalRates[universalRate]
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateUniversalRate(universalRate)
                              },
                            },
                            model: {
                              value: _vm.universalRateValues[universalRate],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.universalRateValues,
                                  universalRate,
                                  $$v
                                )
                              },
                              expression: "universalRateValues[universalRate]",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "grey white--text mr-6 value d-flex align-center" },
      [_c("span", [_vm._v("Minimum Stay")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "grey white--text mr-6 value d-flex align-center" },
      [_c("span", [_vm._v("Maximum Stay")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "grey white--text mr-6 value d-flex align-center" },
      [_c("span", [_vm._v("Check-In")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "grey white--text mr-6 value d-flex align-center" },
      [_c("span", [_vm._v("Check-Out")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "pl-1 pr-1 pt-1 pb-1 mb-2 darker-grey white--text",
        staticStyle: { "min-width": "100%" },
      },
      [
        _c("span", [
          _vm._v(
            "\n                Extra Beds / Guests (for all room types)\n            "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }